import {inject, Injectable} from '@angular/core';
import {SplashScreen} from "@capacitor/splash-screen";
import {AuthService} from "../auth/auth.service";
import {SubscriptionService} from "../subscription/subscription.service";
import {
  combineLatest, Observable, of, shareReplay
} from "rxjs";
import {catchError, switchMap, tap} from "rxjs/operators";
import {LoggerService} from "../logging/logger.service";


@Injectable({
  providedIn: 'root'
})
export class SplashScreenService {
  private readonly logger = inject(LoggerService);

  private splashScreenHidden: boolean = false;
  public splashScreenHidden$?: Observable<boolean>;


  constructor() {
    this.logger.debug('SplashScreen Constructed');
  }

  public async initialise(
    authService: AuthService,
    subscriptionService: SubscriptionService
  ) {
    SplashScreen.show({
      autoHide: false
    }).then(() => {
      this.splashScreenHidden = false
      this.logger.debug('SplashScreen shown');
    });
    this.splashScreenHidden$ = combineLatest([
      authService.initialised$,
      subscriptionService.initialised$
    ]).pipe(
      tap(([authInit, subInit]) =>
        this.logger.debug(
          'SplashscreenState: '
          + authInit + ' - ' + subInit
        )
      ),
      switchMap(([authInit, subInit]) => {
        const allReady = authInit && subInit;
        this.logger.info(
          'All services initialised: '
          + allReady
        );
        if (allReady
          && !this.splashScreenHidden) {
          return of(this.hideSplashScreen());
        } else {
          return of(false);
        }
      }),
      catchError(error => {
        this.logger.error(
          'Error during splash screen '
          + 'initialisation:',
          this.logger.stringify(error)
        );
        return of(false);
      }),
      shareReplay(1)
    );
    this.splashScreenHidden$.subscribe();
    this.logger.info(
      'SplashScreenService initialised'
    );
  }

  private hideSplashScreen() {
    this.logger.info("Hiding splash screen");
    // hide the splash screen in 500ms to allow for any final rendering
    new Promise(resolve => setTimeout(resolve, 500))
      .then(() => SplashScreen.hide().then(() => {
        this.logger.info("SplashScreen hidden");
        this.splashScreenHidden = true;
      }));
    return true;
  }
}
